const INTERVIEWER_COLORS = [
  { bg: 'bg-blue-100', border: 'border-blue-400', text: 'text-blue-800', hex: '#3b82f6' },
  { bg: 'bg-emerald-100', border: 'border-emerald-400', text: 'text-emerald-800', hex: '#10b981' },
  { bg: 'bg-amber-100', border: 'border-amber-400', text: 'text-amber-800', hex: '#f59e0b' },
  { bg: 'bg-rose-100', border: 'border-rose-400', text: 'text-rose-800', hex: '#f43f5e' },
  { bg: 'bg-violet-100', border: 'border-violet-400', text: 'text-violet-800', hex: '#8b5cf6' },
  { bg: 'bg-cyan-100', border: 'border-cyan-400', text: 'text-cyan-800', hex: '#06b6d4' },
  { bg: 'bg-orange-100', border: 'border-orange-400', text: 'text-orange-800', hex: '#f97316' },
  { bg: 'bg-pink-100', border: 'border-pink-400', text: 'text-pink-800', hex: '#ec4899' },
] as const;

export type InterviewerColor = (typeof INTERVIEWER_COLORS)[number];

export function getInterviewerColor(userId: string): InterviewerColor {
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    hash = ((hash << 5) - hash + userId.charCodeAt(i)) | 0;
  }
  const index = Math.abs(hash) % INTERVIEWER_COLORS.length;
  return INTERVIEWER_COLORS[index]!;
}
